import { AccelFile, CourseItemTestQuestion, Entity } from '../../../';
import { action, computed, observable } from 'mobx';

export declare type CourseItemTestCountingMethod = 'percent' | 'score';

export default class CourseItemTest extends Entity {
    constructor(test?: Partial<CourseItemTest>) {
        super(test);
        if (test) this.update(test);
    }

    @observable title: string;
    @observable description: string;
    @observable position: number;
    @observable minPercentageCompletion: number;
    @observable minScoreCompletion: number;
    @observable questions: CourseItemTestQuestion[];
    @observable files: AccelFile[];
    @observable countingMethod: CourseItemTestCountingMethod;
    @observable shuffle: boolean;

    @computed get isValid() {
        return this.questions.length > 0 && this.questions.every(x => x.answers.length > 0);
    }

    @computed get questionScoreSum() {
        return this.questions.map(x => x.score).reduce((a, b) => a + b, 0);
    }

    static fromJson(json: any): CourseItemTest {
        return new CourseItemTest({
            ...json,
            files: json.files ? json.files.map(AccelFile.fromJson) : undefined,
            questions: json.questions ? json.questions.map(CourseItemTestQuestion.fromJson) : undefined
        });
    }

    @action
    update(test: Partial<CourseItemTest>) {
        super.update(test);
    }

    @action addQuestion(q: CourseItemTestQuestion) {
        this.questions.push(q);
    }

    @action deleteQuestion(qId: string) {
        this.questions = this.questions.filter(x => x.id != qId);
    }

    @action insertQuestion(q: CourseItemTestQuestion) {
        const items = this.questions.insert(q, q.position - 1);
        items.forEach((x, i) => x.update({ position: i + 1 }))
        this.questions = items;
    }

    @action reorderQuestions(srcIndex: number, dstIndex: number) {
        const items = this.questions.slice();
        const srcItem = items[srcIndex];
        items.splice(srcIndex, 1);
        items.splice(dstIndex, 0, srcItem);
        items.forEach((x, i) => x.update({ position: i + 1 }))
        this.questions = items;
        return srcItem;
    }
}